export interface EquipmentFilter {
  equipmentTypes?: string[] | null
  isInactive?: boolean | null
  yardBlockIds?: string[] | null
}

export const defaultValues: EquipmentFilter = {
  equipmentTypes: [],
  isInactive: false,
  yardBlockIds: null,
}
